module.exports = __webpack_public_path__ + "img/personGetNumber.be835f7b.svg";